import React from 'react';
import PropTypes from 'prop-types';

function Handshake({ size, strokeWidth, stroke, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path
        strokeWidth={strokeWidth}
        stroke={stroke}
        d="M25.889 18.8775L28.9417 21.9324C29.3652 22.3466 29.935 22.5771 30.5273 22.5738C31.1197 22.5706 31.6869 22.3338 32.1058 21.915C32.5247 21.4962 32.7615 20.929 32.7649 20.3367C32.7683 19.7443 32.5379 19.1745 32.1238 18.7509L24.57 11.1937C23.1969 9.82125 21.6804 9.69075 20.061 11.3107L19.5896 11.7765C19.1646 12.1832 18.5973 12.4073 18.0091 12.4008C17.4209 12.3943 16.8587 12.1578 16.4428 11.7418C16.0269 11.3258 15.7905 10.7635 15.7841 10.1754C15.7777 9.58718 16.0019 9.01989 16.4087 8.595L18 7.00594C19.8371 5.16656 20.8822 4.5 22.4285 4.5H24.8698L34.875 14.499L31.3706 18.0034"
        strokeLinecap="round"
      />
      <path
        strokeWidth={strokeWidth}
        stroke={stroke}
        d="M25.8828 18.877L29.7326 22.725C30.1548 23.1471 30.392 23.7195 30.3921 24.3165C30.3922 24.9135 30.1552 25.486 29.7332 25.9082C29.3111 26.3304 28.7386 26.5676 28.1417 26.5677C27.5447 26.5679 26.9722 26.3308 26.55 25.9088L23.0405 22.3976"
        strokeLinecap="round"
      />
      <path
        strokeWidth={strokeWidth}
        stroke={stroke}
        d="M23.0412 22.3975L25.7552 25.1126C26.1534 25.539 26.3704 26.1033 26.3605 26.6865C26.3506 27.2697 26.1146 27.8263 25.7022 28.2389C25.2899 28.6515 24.7334 28.8878 24.1501 28.898C23.5669 28.9082 23.0025 28.6915 22.576 28.2936L20.9858 26.7028"
        strokeLinecap="round"
      />
      <path
        strokeWidth={strokeWidth}
        stroke={stroke}
        d="M4.75312 18.0043L1.125 14.3756L10.1368 5.36153C10.1368 5.36153 11.3361 6.75765 12.3441 6.75765C13.5669 6.75765 13.8662 6.36053 14.5941 5.63265C15.7888 4.43678 17.5866 4.47222 19.0941 5.97747M21.159 26.8766L21.9409 27.6602C22.3452 28.0854 22.5674 28.6518 22.5601 29.2385C22.5527 29.8252 22.3165 30.3858 21.9018 30.8009C21.487 31.2159 20.9265 31.4526 20.3398 31.4603C19.7531 31.468 19.1866 31.2462 18.7611 30.8422L17.9792 30.0581L21.159 26.8766Z"
        strokeLinecap="round"
      />
      <path
        strokeWidth={strokeWidth}
        stroke={stroke}
        d="M8.775 20.3422C8.99489 20.1359 9.17108 19.8875 9.2931 19.6119C9.41513 19.3362 9.48051 19.0388 9.48535 18.7373C9.49019 18.4359 9.4344 18.1365 9.32129 17.857C9.20818 17.5776 9.04006 17.3237 8.82691 17.1105C8.61376 16.8972 8.35994 16.729 8.08051 16.6158C7.80108 16.5026 7.50175 16.4467 7.2003 16.4514C6.89885 16.4562 6.60142 16.5215 6.32569 16.6434C6.04995 16.7653 5.80153 16.9414 5.59519 17.1612L4.00613 18.7514C3.59936 19.1763 3.37516 19.7436 3.38154 20.3318C3.38792 20.92 3.62439 21.4822 4.04028 21.8982C4.45617 22.3142 5.01842 22.5507 5.60659 22.5572C6.19477 22.5637 6.7621 22.3396 7.18706 21.9329L8.775 20.3422Z"
        strokeLinecap="round"
      />
      <path
        strokeWidth={strokeWidth}
        stroke={stroke}
        d="M11.9576 23.5224C12.3795 23.1004 12.6165 22.5281 12.6164 21.9313C12.6163 21.3345 12.3791 20.7623 11.9571 20.3404C11.535 19.9185 10.9627 19.6815 10.3659 19.6816C9.76917 19.6817 9.1969 19.9189 8.77501 20.3409L6.39114 22.7248C5.98437 23.1497 5.76017 23.717 5.76655 24.3052C5.77293 24.8934 6.0094 25.4556 6.42529 25.8716C6.84118 26.2876 7.40343 26.5241 7.9916 26.5306C8.57978 26.5371 9.14711 26.313 9.57207 25.9063L11.9576 23.5224ZM15.1374 26.7039C15.5395 26.2783 15.7597 25.7127 15.7514 25.1272C15.7431 24.5418 15.5069 23.9826 15.093 23.5685C14.6791 23.1544 14.1201 22.9179 13.5347 22.9093C12.9493 22.9007 12.3835 23.1207 11.9576 23.5224L10.3674 25.1126C9.9633 25.538 9.74132 26.1045 9.74883 26.6912C9.75635 27.2779 9.99276 27.8385 10.4077 28.2534C10.8226 28.6683 11.3831 28.9047 11.9698 28.9122C12.5566 28.9197 13.123 28.6977 13.5484 28.2936L15.1374 26.7039Z"
        strokeLinecap="round"
      />
      <path
        strokeWidth={strokeWidth}
        stroke={stroke}
        d="M18.1451 30.0576C18.354 29.8486 18.5197 29.6006 18.6327 29.3275C18.7458 29.0545 18.8039 28.7619 18.8039 28.4665C18.8038 28.171 18.7456 27.8784 18.6324 27.6054C18.5193 27.3325 18.3535 27.0844 18.1445 26.8755C17.9356 26.6666 17.6875 26.5009 17.4145 26.3879C17.1415 26.2749 16.8489 26.2167 16.5534 26.2168C16.2579 26.2168 15.9653 26.2751 15.6924 26.3882C15.4194 26.5013 15.1714 26.6671 14.9625 26.8761L14.1795 27.6597C13.7696 28.0839 13.5427 28.6523 13.5477 29.2422C13.5527 29.8322 13.7892 30.3965 14.2063 30.8138C14.6234 31.231 15.1877 31.4677 15.7777 31.473C16.3676 31.4782 16.936 31.2515 17.3604 30.8417L18.1451 30.0576Z"
        strokeLinecap="round"
      />
    </svg>
  );
}

Handshake.propTypes = {
  stroke: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Handshake;
